import {
  DELETED_TABLE_DATA,
  DOC_LEVEL_DATA,
  LOADER_STATUS,
  PROCESSED_TABLE_DATA,
  SUMMARY_TABLE_DATA,
  TOTAL_PAGES_DELETED,
  TOTAL_PAGES_PROCESSED,
  RESET_VIEW_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  summaryTableData: [],
  processedTableData: [],
  deletedTableData: [],
  totalPagesProc: 1,
  totalPagesDel: 1,
  docLevelData: [],
};

const imsRecoViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SUMMARY_TABLE_DATA:
      return {
        ...state,
        summaryTableData: action.summaryTableData,
      };
    case PROCESSED_TABLE_DATA:
      return {
        ...state,
        processedTableData: action.processedTableData,
      };
    case DELETED_TABLE_DATA:
      return {
        ...state,
        deletedTableData: action.deletedTableData,
      };
    case TOTAL_PAGES_PROCESSED:
      return {
        ...state,
        totalPagesProc: action.totalPagesProc,
      };
    case TOTAL_PAGES_DELETED:
      return {
        ...state,
        totalPagesDel: action.totalPagesDel,
      };
    case DOC_LEVEL_DATA:
      return {
        ...state,
        docLevelData: action.docLevelData,
      };
    case RESET_VIEW_DATA:
      return {
        ...state,
        summaryTableData: [],
        processedTableData: [],
        deletedTableData: [],
        totalPagesProc: 1,
        totalPagesDel: 1,
        docLevelData: [],
      };
    default:
      return state;
  }
};

export default imsRecoViewReducer;
